import React, { FC, useEffect, useState } from "react";
import CarProgressStepperSection from "@/components/CarProgressStepperSection/CarProgressStepperSection";
import CarPassengerForm from "@/components/forms/CarPassengerForm/CarPassengerForm";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  timelineItemClasses,
} from "@mui/lab";
import CarPaymentMethod from "@/components/CarPaymentMethod/CarPaymentMethod";
import CarBannerSearch from "@/components/CarBannerSearch/CarBannerSearch";
import CarsFormMobile from "@/components/forms/CarsFormMobile/CarsFormMobile";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
interface JourneyDetail {
  label: string;
  value: string;
}
interface CarProps { }

const Car: FC<CarProps> = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const journeyDetails: JourneyDetail[] = [
    { label: "Phone number", value: "1111111111" },
    { label: "Language", value: "English" },
    { label: "Travel intend", value: "00000" },
    { label: "Comments for driver", value: "Testing" },
  ];

  const isMobile = useMediaQuery("(max-width:768px)");
  const router = useRouter();

  useEffect(() => {
    // Replace history state on step change to prevent accumulating states
    window.history.replaceState({ step: currentStep }, "");

    const handlePopState = () => {
      setCurrentStep((prev) => {
        if (prev > 1) {
          return prev - 1;  // Go to the previous step
        } else {
          router.push("/home");  // Redirect to /home when at Step 1
          return prev;
        }
      });
    };

    window.addEventListener("popstate", handlePopState);

    // Ensure that we update the state when the component mounts or when `currentStep` changes
    window.history.replaceState({ step: currentStep }, "");

    return () => window.removeEventListener("popstate", handlePopState);
  }, [currentStep, router]);

  const nextStep = () => {
    setCurrentStep((prev) => prev + 1); // Move to the next step
  };
  return (
    <React.Fragment>
      {currentStep === 1 && <React.Fragment> {!isMobile ? <CarBannerSearch /> : <CarsFormMobile isSearchPage />} </React.Fragment>}

      {!isMobile && <CarProgressStepperSection currentStep={currentStep} setCurrentStep={setCurrentStep} />}
      <section className="flex flex-col justify-between self-stretch w-full items-start relative flex-[0_0_auto] max-w-[1336px] px-4 mx-auto gap-4 mb-8">
        <section className="flex c-md:flex-row flex-col justify-between self-stretch w-full items-start relative gap-6 ">


          {currentStep === 2 && (
            <CarPassengerForm setCurrentStep={setCurrentStep} />
          )}

          {currentStep === 3 && (
            <CarPaymentMethod setCurrentStep={setCurrentStep} />
          )}
          {!(currentStep === 1 && isMobile) && (


            <aside className="flex flex-col w-full max-w-[400px] gap-6">
              <article className="bg-white border border-[#d8dcde] rounded-2xl overflow-hidden flex flex-col">
                <header className="bg-[#f7f9fa] px-4 py-3 border-b border-[#d8dcde]">
                  <h2 className="font-semibold text-sm text-[#1e2f56]">
                    Your journey
                  </h2>
                </header>
                <div className="p-4 space-y-6">
                  <Timeline
                    sx={{
                      padding: 0,
                      [`& .${timelineItemClasses.root}`]: {
                        minHeight: "60px",
                      },
                      [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                      },
                    }}
                  >
                    <TimelineItem>
                      <TimelineSeparator>
                        <TimelineDot
                          sx={{
                            backgroundColor: "#184C9C",
                            border: "2px solid #184C9C",
                            borderRadius: "6px",
                            width: "12px",
                            height: "12px",
                          }}
                        />
                        <TimelineConnector
                          sx={{
                            backgroundColor: "#C29D3C1A",
                            width: "1px",
                          }}
                        />
                      </TimelineSeparator>

                      <TimelineContent sx={{ pb: 4 }}>
                        <time className="text-xs text-gray-500">
                          Tue, 28 Oct · 12:00 PM
                        </time>
                        <p className="text-sm font-semibold text-[#1e2f56]">
                          King Khaled International Airport (RUH)
                        </p>
                        <address className="not-italic text-xs text-gray-500">
                          Riyadh, Saudi Arabia
                        </address>
                      </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                      <TimelineSeparator>
                        <TimelineConnector
                          className="!ms-[5px]"
                          sx={{
                            backgroundColor: "#C29D3C1A",
                            width: "2px",
                          }}
                        />
                      </TimelineSeparator>
                      <TimelineContent sx={{ py: 0 }}>
                        <div className="flex justify-center">
                          <div className="bg-[#C29D3C1A] rounded px-3 py-1">
                            <p className="text-xs text-[#1e2f56] font-medium text-center">
                              About 32 minutes for arrival
                            </p>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                      <TimelineSeparator>
                        <TimelineConnector
                          sx={{
                            backgroundColor: "#C29D3C1A",
                            width: "1px",
                          }}
                        />
                        <TimelineDot
                          sx={{
                            backgroundColor: "#184C9C",
                            border: "2px solid #184C9C",
                            borderRadius: "6px",
                            width: "12px",
                            height: "12px",
                          }}
                        />
                      </TimelineSeparator>

                      <TimelineContent>
                        <time className="text-xs text-gray-500">
                          Tue, 28 Oct · 12:30 PM
                        </time>
                        <p className="text-sm font-semibold text-[#1e2f56]">
                          Dubai International Airport (DXB)
                        </p>
                        <address className="not-italic text-xs text-gray-500">
                          Dubai, United Arab Emirates
                        </address>
                      </TimelineContent>
                    </TimelineItem>
                  </Timeline>
                </div>
                {currentStep !== 1 && (
                  <div className="flex-col items-start gap-2 flex relative p-4">
                    {" "}
                    <header className="flex items-start gap-[144.54px] pt-2 pb-0 px-0 relative self-stretch w-full flex-[0_0_auto] border-t  border-[#e2edf8]">
                      {" "}
                      <h2 className="relative flex items-center justify-center w-fit  font-bold text-primaryText text-[12.8px] tracking-[0] leading-5 whitespace-nowrap">
                        {" "}
                        Journey details{" "}
                      </h2>{" "}
                    </header>{" "}
                    {journeyDetails.map((detail, index) => (
                      <div
                        key={index}
                        className="flex items-start justify-between relative self-stretch w-full flex-[0_0_auto]"
                      >
                        {" "}
                        <dt className="relative flex items-center justify-center w-fit  font-bold text-primaryText text-[12.8px] tracking-[0] leading-5 whitespace-nowrap">
                          {" "}
                          {detail.label}{" "}
                        </dt>{" "}
                        <dd className="items-center justify-center w-fit  font-bold text-primaryText text-sm tracking-[0] leading-5 whitespace-nowrap flex relative">
                          {" "}
                          {detail.value}{" "}
                        </dd>{" "}
                      </div>
                    ))}{" "}
                    <div className="flex items-start justify-between pt-[16.8px] pb-0 px-0 relative border-t-[0.8px] [border-top-style:solid] border-[#e2edf8] w-full  min-h-[36.8px]">
                      {" "}
                      <div className="relative flex items-center justify-center   font-bold text-primaryText text-[12.8px] tracking-[0] leading-5 whitespace-nowrap">
                        {" "}
                        Total booking amount{" "}
                      </div>{" "}
                      <div className="relative flex items-center justify-center   font-bold text-primaryText text-sm tracking-[0] leading-5 whitespace-nowrap">
                        {" "}
                        AED 517.78{" "}
                      </div>{" "}
                    </div>
                  </div>)}
              </article>

              <article className="bg-white border border-[#d8dcde] rounded-2xl overflow-hidden flex flex-col">
                <header className="bg-[#f7f9fa] px-4 py-3 border-b border-[#d8dcde]">
                  <h2 className="font-semibold text-sm text-[#1e2f56]">
                    Policies
                  </h2>
                </header>

                <div className="p-4 space-y-3">
                  <h3 className="font-bold text-sm text-[#1e2f56]">
                    Free cancellation
                  </h3>
                  <div className="flex gap-2 items-center">
                    <div className="w-5 h-5 flex-shrink-0">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                          fill="#EAF5EB"
                        />
                        <path
                          d="M15.4375 9.8125L11.0625 14.1873L8.875 12"
                          stroke="#319E37"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="text-sm text-[#4b4b4b] leading-5">
                      Cancel for free up to 24 hours before you go
                    </p>
                  </div>
                </div>
              </article>
            </aside>
          )}
        </section>
      </section>
    </React.Fragment>
  );
};

export default Car;
